export const RSS_FEED_SEARCH_DEFAULTS = {
  alignment: 'center' as const,
  maxWidth: '600px',
  maxHeight: '60px',
  marginBottom: '16px',
  borderWidth: '1px',
  borderColor: '#e5e7eb',
  borderStyle: 'solid',
  borderRadius: '8px',
  borderFocus: '#3b82f6',
  backgroundColor: '#ffffff',
  textColor: '#111827',
  placeholderColor: '#6b7280',
  iconFill: '#3b82f6',
  placeholder: 'Search',
};
